import React from 'react';
import { DialogV2 } from '@/components/custom/erp';
import { AritoIcon } from '@/components/custom/erp';
import { Button } from '@/components/custom/erp';
import { Group } from '@/types/schemas';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedObj: Group | null;
  deleteSupplierGroup: (uuid: string) => Promise<boolean | undefined>;
  clearSelection: () => void;
}

function DeleteDialog({ onClose, open, selectedObj, deleteSupplierGroup, clearSelection }: DeleteDialogProps) {
  const handleDelete = async () => {
    if (selectedObj) {
      try {
        await deleteSupplierGroup(selectedObj.uuid);
        clearSelection();
        onClose();
      } catch (error) {
        console.error('Error deleting group:', error);
      }
    }
  };
  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Xóa dữ liệu'
      maxWidth='lg'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
      actions={
        <>
          <Button
            className='bg-[rgba(15,118,110,0.9)] text-white hover:bg-[rgba(15,118,110,1)]'
            onClick={handleDelete}
            type='submit'
            form='search-form'
          >
            <AritoIcon icon={884} marginX='4px' />
            Đồng ý
          </Button>
          <Button onClick={onClose} variant='outline'>
            <AritoIcon icon={885} marginX='4px' />
            Huỷ
          </Button>
        </>
      }
    >
      <p className='min-w-[40vw] p-4 text-base font-medium'>Bạn có chắc chắn xóa không?</p>
    </DialogV2>
  );
}

export default DeleteDialog;
